<template>
    <div>
        <div class="d-flex justify-content-center mb-3">
            <ul class="nav nav-pills">
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="aba == 'visao' ? 'active' : ''" @click.prevent="abrir('visao')">
                        Visão Geral
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="( !aba || aba == 'lista' ) ? 'active' : ''" @click.prevent="abrir('lista')" >
                        Lista
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="( aba == 'orcs' ) ? 'active' : ''" @click.prevent="abrir('orcs')" >
                        Orçamentos
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="( aba == 'solics' ) ? 'active' : ''" @click.prevent="abrir('solics')" >
                        Solicitantes
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="( aba == 'relacionamento' ) ? 'active' : ''" @click.prevent="abrir('relacionamento')" >
                        Relacionamento Médico
                    </a>
                </li>
            </ul>
        </div>

        <crm-orcamentos v-if="aba == 'orcs'" />
        <crm-solicitantes v-else-if="aba == 'solics'" />
        <cadastro-medico-solicitante :crm="true" v-else-if="aba == 'relacionamento'" />

        <template v-else>

            <div class="card dashcard mb-0">
                <div class="card-body">
                    <div class="form-row">
                        <div class="col col-12 col-md-6">
                            <az-periodo v-model="filtro" :sync="true" @sync="load()" />
                        </div>
                        <div class="col col-12 col-md-3">
                            <az-input
                                type="select"
                                :optionsList="$util.unidades_com_tags(true, true)"
                                optionsData="id_unidade_operacao"
                                icon="fa fa-building fa-fw"
                                placeholder="Todas as Unidades..."
                                v-model="filtro.id_unidade_operacao" />
                        </div>
                        <div class="col col-12 col-md-3">
                            <az-input
                                type="select" 
                                optionsMode="json"
                                :optionsList="lista_status"
                                optionsData="id_contato_status"
                                placeholder="Todos os status..."
                                icon="fa fa-filter" 
                                :edicao="!!( lista_status && lista_status.length )"
                                v-model="filtro.id_contato_status" />
                        </div>
                    </div>
                    <div class="form-row mt-2">
                        <div class="col col-12" :class=" ( fila && fila.model_type == 'cancelados' ) ? 'col-md-3' : 'col-md-6'">
                            <az-input
                                icon="fa-solid fa-table-list fa-fw"
                                placeholder="Selecione o Tipo..."
                                type="select"
                                :optionsList="filas.map(item => { return { id: item.id_fila_lead, search: item.search } })"
                                optionsData="id"
                                optionsDisplay="search"
                                v-model="filtro.id_fila_lead"
                                :edicao="!$store.state.loading">
                                <template v-if="is_fila_orcamento" v-slot:buttonposb>
                                    <importacao service="orcamentos" @refresh="load()" />
                                    <div class="input-group-append">
                                        <router-link :to="{ name: 'crmorcamento' }" class="btn btn-outline-primary">
                                            <i class="fa fa-plus" aria-hidden="true"></i>
                                        </router-link>
                                        <button type="button" class="btn btn-outline-primary" title="Adicionar Filtros." @click="incluir_filtro()">
                                            <i class="fa-solid fa-filter"></i>
                                        </button>
                                    </div>
                                </template>

                                <template v-else-if="is_fila_atendimento" v-slot:buttonposb>
                                    <importacao service="atendimentos" @refresh="load()" :chunk_size="5" />
                                    <div class="input-group-append">
                                        <button type="button" class="btn btn-outline-primary" title="Adicionar Filtros." @click="incluir_filtro()">
                                            <i class="fa-solid fa-filter"></i>
                                        </button>
                                    </div>
                                </template>

                                <template v-else-if="is_fila_cuidado" v-slot:buttonposb>
                                    <div class="input-group-append">
                                        <button type="button" class="btn btn-outline-primary" title="Incluir paciente em programa de cuidado coordenado." @click="incluir_programa()">
                                            <i class="fa fa-plus" aria-hidden="true"></i>
                                        </button>
                                        <button type="button" class="btn btn-outline-primary" title="Adicionar Filtros." @click="incluir_filtro()">
                                            <i class="fa-solid fa-filter"></i>
                                        </button>
                                    </div>
                                </template>

                                <template v-else-if="filtro.id_fila_lead" v-slot:buttonposb>
                                    <div class="input-group-append">
                                        <button type="button" class="btn btn-outline-primary" title="Adicionar Filtros." @click="incluir_filtro()">
                                            <i class="fa-solid fa-filter"></i>
                                        </button>
                                    </div>
                                </template>
                            </az-input>
                        </div>
                        <div class="col col-12 col-md-3" v-if="fila && fila.model_type == 'cancelados'">
                            <az-input
                                icon="fa-solid fa-circle-question"
                                placeholder="Motivo do Cancelamento..."
                                type="select" 
                                optionsMode="aql"
                                service="motivos.index"
                                :optionsParm="{ tipo: 'atp'}"
                                optionsData="id_motivo"
                                v-model="filtro.id_motivo" />
                        </div>
                        <div class="col col-12 col-md-3">
                            <az-input icon="fas fa-user-md fa-fw" 
                                type="select" 
                                optionsMode="aql"
                                service="medicos.index"
                                optionsName="medicos-guia"
                                optionsData="id_pessoa"
                                placeholder="Todos os Executantes..."
                                :optionsParm="{ ativos: true }"
                                v-model="filtro.id_medico" />
                        </div>
                        <div class="col col-12 col-md-3">
                            <az-input
                                icon="fa-solid fa-hand-point-up"
                                placeholder="Solicitante..."
                                type="autocomplete"
                                optionsMode="aql"
                                service="medico_solicitantes.index"
                                optionsDisplay="search"
                                optionsData="id_medico_solicitante"
                                :optionsSync="true"
                                :edicao="tem_solicitante"
                                v-model="filtro.id_medico_solicitante">
                            </az-input>
                        </div>
                    </div>
                    <div class="form-row mt-2" v-if="aba != 'visao'">
                        <div class="col col-12 col-md-6">
                            <az-input icon="fa fa-search fa-fw" placeholder="Pesquisar..." v-model="search">
                                <template v-slot:buttonposb>
                                    <div class="input-group-append" v-if="lista && lista.length">
                                        <span class="input-group-text">
                                            {{ lista.length }}
                                        </span>
                                    </div>
                                    <print-export printid="lista-de-trabalho" :left="true" :dados="dados_exportacao" />
                                </template>
                            </az-input>
                        </div>

                        <div class="col col-12 col-md-4">
                            <az-input 
                                placeholder="Selecionar paciente..."
                                icon="fas fa-user"
                                type="autocomplete" 
                                optionsMode="aql"
                                service="pacientes.index"
                                optionsDisplay="search"
                                ref="info_paciente"
                                v-model="paciente" 
                                :optimized_ac="true"/>
                        </div>

                        <div class="col col-12 col-md-2">
                            <az-input
                                type="checkbox-group"
                                label="Exibir Texto Registro"
                                v-model="exibir_contato" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="progress mt-1 mb-2" v-if="lista && lista.length">
                <div class="indeterminate" v-if="$store.state.loading"></div>
                <div class="determinate" v-else></div>
            </div>    

            <div class="mb-3" v-else>
            </div>

            <div v-if="obs" class="alert alert-info">
                {{ obs }}
            </div>

            <template v-if="aba == 'visao'">
                <az-empty-state 
                    v-if="!contadores || !contadores.length" 
                    :msg="!first_load ? ( filtro.id_fila_lead ? 'Buscar' : 'Selecione o Tipo...' ) : 'Nenhum oportunidade identificada.'"
                    :icon="!first_load ? ( filtro.id_fila_lead ? 'fa-solid fa-rotate' : 'fa-solid fa-table-list' ) : 'fa-solid fa-user' "
                    :action="( !first_load && filtro.id_fila_lead ) ? 'Buscar' : ''"
                    :method="load" />

                <div class="form-row" v-else>
                    <div class="col col-12 col-md-3 mb-2" v-for="(contador, icx) in contadores" :key="icx">
                        <div class="card h-100 mb-0 dashcard">
                            <div class="card-body d-flex justify-content-between py-2" :class="'alert-' + contador.color">
                                <div>
                                    <div class="lead">
                                        <a href="#" @click.prevent="filtrar_status(contador)" class="card-link">
                                            {{ contador.status }}
                                        </a>
                                    </div>
                                </div>
                                <div>
                                    <span class="display-4">
                                        {{ contador.qtde }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col col-12 col-md-3 mb-2" v-if="contadores && contadores.length > 1">
                        <div class="card h-100 mb-0 dashcard">
                            <div class="card-body d-flex bg-dark text-white justify-content-between py-2">
                                <div>
                                    <div class="lead">
                                        <a href="#" @click.prevent="filtrar_status({ id_contato_status: '' })" class="card-link text-white">
                                            Total
                                        </a>
                                    </div>
                                </div>
                                <div>
                                    <div class="display-4">
                                        {{ totalizar(contadores, 'qtde') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>

            <template v-else>
                <az-empty-state 
                    v-if="!lista || !lista.length" 
                    :msg="!first_load ? ( filtro.id_fila_lead ? 'Buscar' : 'Selecione o Tipo...' ) : 'Nenhum oportunidade identificada.'"
                    :icon="!first_load ? ( filtro.id_fila_lead ? 'fa-solid fa-rotate' : 'fa-solid fa-table-list' ) : 'fa-solid fa-user' "
                    :action="( !first_load && filtro.id_fila_lead ) ? 'Buscar' : ''"
                    :method="load" />
            
                <!-- Lista de items -->

                <template  v-else>

                    <div v-if="tags && tags.length">
                        <table class="table table-sm border-0 mb-1 table-responsive">
                            <tr>
                                <td class="text-nowrap">
                                    <a href="#" @click.prevent="set_pesquisa(classe)" v-for="(classe, icx) in tags" :key="icx">
                                        <span class="badge badge-success mr-1" >
                                            {{ classe }}
                                        </span>
                                    </a>
                                </td>
                            </tr>
                        </table>
                    </div>

                    

                    <div class="mt-3" id="lista-de-trabalho">

                        <cabecalho-generico
                            titulo="CRM - Leads">
                            <div>
                                <div v-if="parametros">
                                    Período: {{ $util.getFormatDate(parametros.inicio) }} a {{ $util.getFormatDate(parametros.fim) }}
                                </div>
                                <div v-if="obs">
                                    {{ obs }}
                                </div>      
                            </div>
                        </cabecalho-generico>

                        <div class="mb-3">
                            <div class="text-right small text-muted" v-if="dados && dados.to > 0">
                                {{ dados.from }} - {{ dados.to }} / {{ dados.total }}
                            </div>
                            
                            <div class="card carde mb-2 w3-animate-opacity" v-for="(item, index) in lista" :key="index">
                                <div class="card-body py-1 px-2" 
                                    :class="( item.contatos.length && item.contatos[0].contato_status.st_color )
                                            ? 'alert-' + item.contatos[0].contato_status.st_color
                                            : 'bg-white' ">
                                    <div class="row align-items-center">
                                        <!-- Ação -->
                                        <div class="col-12 col-md-2 col-lg-2 my-2 my-md-auto">
                                            <div class2="d-flex flex-column">
                                                <div class="text-nowrap text-truncate">
                                                    <button
                                                        type="button" title="Editar"
                                                        class="btn btn-outline-primary btn-sm mr-2 mb-1"
                                                        data-toggle="tooltip" data-placement="top"
                                                        @click="editar (item)">
                                                        <i class="fas fa-edit"></i>
                                                    </button>
                                                    <template v-if="item.items">
                                                        <span class="badge badge-secondary mr-2">{{ item.items.length }}</span>
                                                        <span class="small text-muted">
                                                            {{ item.lista_items }}
                                                        </span>
                                                    </template>
                                                    <template v-else-if="false && item.procedimento">
                                                        <span class="small text-muted">
                                                            {{ item.procedimento.search }}
                                                        </span>
                                                    </template>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- Data -->
                                        <div class="col col-12 col-md-2"> 
                                            <div>
                                                <template v-if="item.cuidado && item.cuidado.programa">
                                                    <div>
                                                        <span class='badge' :class="'badge-' + ( item.cuidado.programa.st_cor ? item.cuidado.programa.st_cor : 'secondary' )"
                                                            :title="item.cuidado.programa.st_cuidado_programa">
                                                            {{ 
                                                                item.cuidado.programa.st_sigla 
                                                                ? item.cuidado.programa.st_sigla
                                                                : item.cuidado.programa.st_cuidado_programa 
                                                            }}
                                                        </span>
                                                    </div>
                                                </template>

                                                <template v-if="item.dt_inclusao">
                                                    {{ $util.getFormatDate(item.dt_inclusao) }} {{ item.dt_inclusao.substr(11,5) }}
                                                </template>
                                                <template v-else-if="item.dt_inicio">
                                                    {{ $util.getFormatDate(item.dt_inicio) }} {{ item.dt_inicio.substr(11,5) }}
                                                </template>
                                                <template v-else-if="item.created_at">
                                                    {{ $util.getFormatDate(item.created_at) }} {{ item.created_at.substr(11,5) }}
                                                </template>

                                                <span class="ml-2" v-if="item.atendimento && item.atendimento.marcacao && item.atendimento.marcacao.sinalizador_atendimento">
                                                    <i :class="( item.atendimento.marcacao.sinalizador_atendimento.st_icon ? item.atendimento.marcacao.sinalizador_atendimento.st_icon : 'fas fa-flag' ) + ' text-' + item.atendimento.marcacao.sinalizador_atendimento.st_cor"
                                                        :title="item.atendimento.marcacao.sinalizador_atendimento.search"></i>
                                                </span>

                                                <span class="ml-2" v-if="item.id_requisicao && item.doc_certificado">
                                                    <i class="fa-solid fa-signature"></i>
                                                </span>

                                                <span class="ml-2" v-else-if="item.laudo && item.laudo.doc_certificado">
                                                    <i class="fa-solid fa-signature"></i>
                                                </span>
                                            </div>
                                            <div>
                                                <span class="mr-2">
                                                    <span v-if="item.contatos.length">
                                                        {{ item.contatos[0].contato_status.search }}
                                                    </span>
                                                    <span v-else>
                                                        Registrado
                                                    </span>
                                                </span>
                                                <small class="text-muted">
                                                    <template v-if="item.id_cuidado_paciente">
                                                        #{{ item.id_cuidado_paciente }}
                                                    </template>
                                                    <template v-else-if="item.id_atendimento">
                                                        <a href="#" @click.prevent="abrir_atendimento(item.id_atendimento)" class="card-link">
                                                            #{{ item.id_atendimento }}
                                                        </a>
                                                    </template>
                                                    <template v-else-if="item.id_orcamento">
                                                        #{{ item.id_orcamento }}
                                                    </template>
                                                    <template v-else-if="item.anamnese">
                                                        <a href="#" @click.prevent="abrir_atendimento(item.anamnese.atendimento_procedimento.id_atendimento)" class="card-link">
                                                            #{{ item.anamnese.atendimento_procedimento.id_atendimento }}
                                                        </a>
                                                    </template>
                                                </small>
                                            </div>
                                            <div v-if="item.integra_crm && item.integra_crm.st_id_externo">
                                                <span class="badge badge-dark">CRM: {{ item.integra_crm.st_id_externo }}</span>
                                            </div>
                                            <div v-if="item.js_classes && item.js_classes.length">
                                                <span class="badge badge-success mr-1" v-for="(classe, icx) in item.js_classes" :key="icx">
                                                    {{ classe }}
                                                </span>
                                            </div>
                                            <div v-if="item.laudo && item.laudo.status_laudo">
                                                <span :class="item.laudo.status_laudo.st_color ? 'badge badge-' + item.laudo.status_laudo.st_color : 'badge badge-secondary'">
                                                    {{ item.laudo.status_laudo.st_status_laudo }}
                                                </span>
                                            </div>
                                        </div>
                                        <!-- Identificação do Paciente -->
                                        <template v-if="!item.id_retorno_atendimento && item.id_cuidado_paciente">
                                            <div class="col col-12 col-md-4">
                                                <celula-dados-paciente :hor="{ marcacao: item }" :callback_paciente="selecionar_paciente" />
                                            </div>

                                            <div class="col col-12 col-md-4 d-flex justify-content-between">
                                                <div>
                                                    <celula-dados-procedimento :hor="{ marcacao: item }" />
                                                </div>
                                            </div>
                                        </template>

                                        <template v-else-if="item.anamnese && item.anamnese.atendimento_procedimento.atendimento.paciente">
                                            <div class="col col-12 col-md-4">
                                                <celula-dados-paciente :hor="dados_paciente(item.anamnese)" 
                                                    :callback_paciente="selecionar_paciente" />
                                            </div>
                                            <div class="col col-12 col-md-4 d-flex justify-content-between">
                                                <div>
                                                    <celula-dados-procedimento :hor="dados_procedimento(item.anamnese)" @abriranexos="abrir_anexar_arquivo" />
                                                </div>

                                                <!-- Menu de opções -->
                                                <div class="dropleft d-flex align-items-center justify-content-center order-1 order-md-2" v-if="!fila_com_filtro">
                                                    <a href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown"
                                                        aria-haspopup="true" aria-expanded="false">
                                                        <i class="fas fa-ellipsis-v"></i>
                                                    </a>
                                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                        <button class="dropdown-item" @click="ver_documentos(item, true)">
                                                            <i class="fas fa-clipboard-list fa-fw mr-2"></i>
                                                            Requisições / Relatórios
                                                        </button>
                                                        <button class="dropdown-item" @click="assinar_requisicao(item)" v-if="false && item.id_requisicao && !item.doc_certificado && $store.state.user.medico">
                                                            <i class="fa-solid fa-signature fa-fw mr-2"></i>
                                                            Assinar Requisição
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                        <template v-else-if="item.id_atendimento_procedimento">
                                            <div class="col col-12 col-md-4">
                                                <celula-dados-paciente :hor="{ marcacao: item.atendimento }" 
                                                    :callback_paciente="selecionar_paciente" />
                                            </div>
                                            <div class="col col-12 col-md-4 d-flex justify-content-between">
                                                <celula-dados-procedimento :hor="dados_procedimento_atp(item)" />

                                                <!-- Menu de opções -->
                                                <div class="dropleft d-flex align-items-center justify-content-center order-1 order-md-2" v-if="!fila_com_filtro">
                                                    <a href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown"
                                                        aria-haspopup="true" aria-expanded="false">
                                                        <i class="fas fa-ellipsis-v"></i>
                                                    </a>
                                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                        <button class="dropdown-item" @click="ver_documentos(item)">
                                                            <i class="fas fa-clipboard-list fa-fw mr-2"></i>
                                                            Requisições / Relatórios
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                        <!-- Orçamento -->
                                        <template v-else-if="item.id_orcamento">
                                            <div class="col col-12 col-md-4">
                                                <div v-if="item.st_titulo" class="small text-muted">
                                                    {{ item.st_titulo }}
                                                </div>
                                                <celula-dados-paciente 
                                                    :hor="{ marcacao: item }" 
                                                    :callback_paciente="selecionar_paciente" />
                                            </div>
                                            <div class="col col-12 col-md-4 d-flex justify-content-between">
                                                <div>
                                                    <div v-if="item.solicitante" class="small text-muted" title="Solicitante">
                                                        {{ item.solicitante.st_nome }}
                                                    </div>
                                                    <celula-dados-procedimento 
                                                        v-if="dados_procedimento_orc(item).marcacao.procedimento"
                                                        :hor="dados_procedimento_orc(item)"
                                                        :total="item.valor_total">
                                                    </celula-dados-procedimento>
                                                </div>
                                                
                                                <!-- Menu de opções -->
                                                <div class="dropleft d-flex align-items-center justify-content-center order-1 order-md-2">
                                                    <a href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown"
                                                        aria-haspopup="true" aria-expanded="false">
                                                        <i class="fas fa-ellipsis-v"></i>
                                                    </a>
                                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                        <button class="dropdown-item" @click="ver_orcamento(item)">
                                                            Abrir Orçamento
                                                        </button>

                                                        <button class="dropdown-item" @click="chamar_orcamento(item)">
                                                            Chamar Paciente 
                                                        </button>

                                                        <template v-if="flKualizCrm">

                                                            <button class="dropdown-item" @click="integrar_com_kualiz(item)" v-if="!item.integra_crm">
                                                                Criar Oportunidade no Kualiz
                                                            </button>

                                                            <button class="dropdown-item" @click="integrar_com_kualiz(item)" v-else>
                                                                Atualizar Oportunidade no Kualiz ({{ item.integra_crm.st_id_externo }})
                                                            </button>

                                                        </template>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                        <!-- Marcação / Faltosos -->
                                        <template v-else-if="item.id_marcacao">
                                            <div class="col col-12 col-md-4">
                                                <celula-dados-paciente :hor="{ marcacao: item }" :callback_paciente="selecionar_paciente" />
                                            </div>
                                            <div class="col col-12 col-md-4 d-flex justify-content-between">
                                                <celula-dados-procedimento :hor="{ marcacao: item }" />

                                                <!-- Menu de opções -->
                                                <div class="dropleft d-flex align-items-center justify-content-center order-1 order-md-2">
                                                    <a href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown"
                                                        aria-haspopup="true" aria-expanded="false">
                                                        <i class="fas fa-ellipsis-v"></i>
                                                    </a>
                                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton"  >
                                                        <button class="dropdown-item" @click="anexar_laudo(item)" v-if="anexar_laudo_atendido">
                                                            Anexar Laudo
                                                        </button>

                                                        <button class="dropdown-item" @click="verColeta(item)" v-else-if="!fila_com_filtro">
                                                            Amostras
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                                <div class="card-footer py-1 px-2 small" v-if="item.ch_estado_marcacao == 'C'" title="Informações do Cancelamento.">
                                    <span v-if="item.motivo_canc">
                                        <a href="#" @click.prevent="set_pesquisa(item.motivo_canc.search)" class="card-link">
                                            {{ item.motivo_canc.search }}
                                        </a>
                                        <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                    </span>
                                    <span v-if="item.usuario_cancelamento">
                                        <a href="#" @click.prevent="set_pesquisa(item.usuario_cancelamento.st_login)" class="card-link">
                                            {{ item.usuario_cancelamento.st_login }}
                                        </a>
                                        <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                    </span>
                                    <span v-if="item.dt_cancelamento">
                                        {{ $util.getFormatDate(item.dt_cancelamento) }}
                                        {{ item.dt_cancelamento.slice(11,16) }}
                                        <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                    </span>
                                    {{ item.st_motivo_cancelamento }}
                                </div>
                                <div class="card-footer py-1 px-2 small" v-else-if="item.contatos && item.contatos.length && exibir_contato">
                                    {{ $util.getFormatDate(item.contatos[0].created_at) }}
                                    <i class="fa-solid fa-caret-right mx-1"></i>
                                    {{ item.contatos[0].usuario ? item.contatos[0].usuario.st_login : '' }}
                                    <i class="fa-solid fa-caret-right mx-1"></i>
                                    {{ item.contatos[0].st_observacoes }}
                                </div>
                            </div>
                        </div>
                    </div>

                </template>

                <div v-if="flKualizCrm && aba != 'visao' && lista && lista.length"> 
                    <button type="button" class="btn btn-primary" @click="integrar_todos()">
                        Integrar Oportunidades no Kualiz    
                    </button>
                </div>

            </template>

            <template v-if="1 == 0">
                <pre v-if="lista.length">{{ lista }}</pre>
                <pre>{{ lista_status }}</pre>
            </template>

            <!-- Modal -->
            <div class="modal fade" id="crmContatosModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
                <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                    <div class="modal-content" v-if="edicao && novo_contato">
                        <div class="modal-header">
                            <h5 class="modal-title">Contatos: 
                                <template v-if="edicao.id_cuidado_paciente">
                                    {{ edicao.paciente.st_nome }}
                                    - {{ $util.getFormatDate(edicao.created_at) }}
                                </template>
                                <template v-else-if="edicao.id_atendimento">
                                    {{ edicao.atendimento.paciente.st_nome }}
                                    - {{ $util.getFormatDate(edicao.atendimento.dt_inicio) }}
                                </template>
                                <template v-else-if="edicao.anamnese">
                                    {{ edicao.anamnese.atendimento_procedimento.atendimento.paciente.st_nome }}
                                    - {{ $util.getFormatDate(edicao.dt_inclusao) }}
                                </template>
                                <template v-if="edicao.id_orcamento">
                                    {{ edicao.nome_paciente }} - {{ $util.getFormatDate(edicao.created_at) }}
                                </template>
                                <template v-else-if="edicao.id_marcacao">
                                    {{ edicao.nome_paciente }} - {{ $util.getFormatDate(edicao.dt_inicio) }}
                                </template>
                            </h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">

                            <template v-if="!edicao.id_atendimento && edicao.anamnese">
                                <div v-if="edicao.dt_inclusao.substr(0,10) != edicao.anamnese.atendimento_procedimento.atendimento.dt_inicio.substr(0,10)">
                                    Atendimento: {{ $util.getFormatDate(edicao.anamnese.atendimento_procedimento.atendimento.dt_inicio) }}
                                </div>
                            </template>

                            <div class="alert alert-warning mb-3" v-if="edicao.st_observacoes">
                                {{ edicao.st_observacoes }}
                            </div>

                            <div class="row">
                                <div class="col col-12 col-md-8">
                                    <az-input
                                        required 
                                        :validate="validate"
                                        type="select" 
                                        optionsMode="json"
                                        :optionsList="lista_status.filter(item => item.id_contato_status != 'R')"
                                        optionsData="id_contato_status"
                                        placeholder="Selecione o status..."
                                        v-model="novo_contato.id_contato_status" />

                                    <az-input
                                        required 
                                        :validate="validate"
                                        label="Comentários"
                                        type="textarea"
                                        rows="5"
                                        v-model="novo_contato.st_observacoes" />

                                    <hr> 

                                    <ul class="list-group small">
                                        <li class="list-group-item" v-for="(contato, idx) in edicao.contatos" :key="idx"
                                            :class="!idx ? 'list-group-item-info' : ''">
                                            <span class="mr-3">{{ contato.contato_status.search }}</span>
                                            <span class="text-muted">{{ contato.usuario.st_login }} em {{ $util.getFormatDate(contato.created_at) }} {{ contato.created_at.substr(11,5) }}</span>
                                            <div>{{ contato.st_observacoes }}</div>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col col-12 col-md-4">
                                    <template v-if="edicao.id_cuidado_paciente">

                                        <ul class="list-group small">
                                            <li class="list-group-item d-flex justify-content-between" v-for="(retorno, irr) in edicao.retornos" :key="irr">
                                                <div>{{ retorno.procedimento.search }}</div>
                                                <div>{{ $util.getFormatDate(retorno.dt_retorno) }}</div>
                                            </li>
                                        </ul>

                                    </template>

                                    <template v-else-if="edicao.id_atendimento_procedimento">

                                        <ul class="list-group small">
                                            <li class="list-group-item d-flex justify-content-between">
                                                <div>{{ edicao.procedimento.search }}</div>
                                                <div v-if="edicao.id_procedimento == edicao.atendimento.marcacao.id_procedimento">
                                                    <button type="button" class="btn btn-outline-primary btn-sm" data-toggle2="tooltip"
                                                        data-placement="top" title="Marcar" @click="agendar_retorno(edicao)">
                                                        <i class="fa fa-calendar-plus-o" aria-hidden="true"></i>
                                                    </button>
                                                </div>
                                            </li>
                                        </ul>

                                    </template>

                                    <template v-else-if="edicao.items">

                                        <ul class="list-group small">
                                            <li class="list-group-item d-flex justify-content-between" v-for="(item, idx) in edicao.items" :key="idx">
                                                <div v-if="item.item">
                                                    {{ item.item.search }}
                                                    <span class="badge badge-secondary ml-2" v-if="item.in_quantidade > 1" title="Quantidade">x{{ item.in_quantidade }}</span>
                                                    <div class="text-muted" style="white-space: pre-wrap;">{{ item.st_observacoes }}</div>
                                                </div>
                                                <div v-else-if="item.procedimento">{{ item.procedimento.search }}</div>

                                                <div v-if="item.id_requisicao_procedimento">
                                                    <button
                                                        type="button"
                                                        class="btn btn-outline-primary btn-sm"
                                                        data-toggle2="tooltip"
                                                        data-placement="top"
                                                        title="Marcar"
                                                        @click="agendar(item)"
                                                    >
                                                        <i class="fa fa-calendar-plus-o" aria-hidden="true"></i>
                                                    </button>
                                                </div>

                                                <div v-else-if="edicao.id_retorno_atendimento">
                                                    <button
                                                        type="button"
                                                        class="btn btn-outline-primary btn-sm"
                                                        data-toggle2="tooltip"
                                                        data-placement="top"
                                                        title="Marcar"
                                                        @click="agendar_retorno(edicao)">
                                                        <i class="fa fa-calendar-plus-o" aria-hidden="true"></i>
                                                    </button>
                                                </div>
                                                
                                            </li>
                                        </ul>

                                        <div v-if="edicao.id_requisicao" class="mt-3">
                                            <div class="row">
                                                <div class="col col-12 d-flex flex-column">
                                                    <button type="button" class="btn btn-outline-success" @click="gerar_orcamento(edicao)">
                                                        <i class="fas fa-file-invoice-dollar mr-2"></i>
                                                        Gerar Orçamento
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <ul class="list-group mt-3" v-if="edicao.orcamentos && edicao.orcamentos.length">
                                            <li class="list-group-item" v-for="(orc, iox) in edicao.orcamentos" :key="iox">
                                                Orçamento: 
                                                <a href="#" @click.prevent="ver_orcamento(orc)" class="card-link">
                                                    #{{ orc.id_orcamento }}
                                                </a>
                                                <template v-if="orc.marcacoes">
                                                    <div v-for="(marc, imx) in orc.marcacoes" :key="imx">
                                                        <div>
                                                            <i class="fa fa-calendar-plus-o fa-fw mr-2" aria-hidden="true"></i>
                                                            {{ $util.getFormatDate(marc.dt_inicio) }}
                                                            {{ marc.dt_inicio.substr(11,5) }}
                                                            <span v-if="marc.id_atendimento">
                                                                <i class="fa fa-caret-right mx-3" aria-hidden="true"></i>
                                                                #{{ marc.id_atendimento }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </template>
                                                
                                            </li>
                                        </ul>

                                    </template>

                                    <template v-else-if="edicao.id_marcacao">
                                        <ul class="list-group small">
                                            <li class="list-group-item d-flex justify-content-between">
                                                <div>{{ edicao.procedimento.search }}</div>
                                                <div>
                                                    <button type="button" class="btn btn-outline-primary btn-sm" data-toggle2="tooltip"
                                                        data-placement="top" title="Remarcar" @click="remarcar(edicao)">
                                                        <i class="fa fa-calendar-plus-o" aria-hidden="true"></i>
                                                    </button>
                                                </div>
                                            </li>
                                        </ul>
                                    </template>
                                </div>
                            </div>

                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                            <az-submit @click="salvar_contato()">Registrar Contato</az-submit>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Paginação -->
            <nav class="navbar fixed-bottom navbar-light bg-light pb-3" v-if="dados && ( dados.last_page > 1 || ( !dados.last_page && dados.to >= dados.per_page ) )">
                <div class="d-flex">
                    <paginate
                        class="mb-0"
                        :page-count="dados.last_page ? dados.last_page : ( dados.current_page + 1 )"
                        :container-class="'pagination'"
                        :page-class="'page-item'"
                        :page-link-class="'page-link'"
                        :prev-class="'page-link'"
                        :next-class="'page-link'"
                        :prev-text="'<<'"
                        :next-text="'>>'"
                        :click-handler="paginar">
                    </paginate>
                </div>
            </nav>

            <!-- Modal Requisições / Documentos -->
            <div class="modal fade" id="documentosModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
                <div class="modal-dialog modal-xl" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Requisições e Documentos</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div v-if="edicao_atendimento">

                                <div class="card">
                                    <div class="card-body">
                                        <celula-dados-paciente :hor="{ marcacao: edicao_atendimento }" />
                                    </div>
                                    <div class="card-body">
                                        #{{ edicao_atendimento.id_atendimento }}
                                    </div>
                                </div>

                                <div class="form-row mt-2">
                                    <div class="col col-12 col-md-6">
                                        <div>Requisições:</div>
                                        <ul class="list-group">
                                            <li class="list-group-item d-flex justify-content-between" v-if="!lista_requisicoes.length">
                                                Nenhuma requisição registrada.
                                            </li>
                                            <li class="list-group-item d-flex justify-content-between" v-for="(requisicao, irx) in lista_requisicoes" :key="irx">
                                                <div>
                                                    <div v-for="(lista_items, grupo, igx) in agrupar_items(requisicao.items, true)" :key="igx" :class="igx ? 'mt-1' : ''">
                                                        <span v-if="grupo">
                                                            <span class="badge badge-secondary mr-2">{{ grupo }}</span>
                                                        </span>
                                                        <span class="small">
                                                            {{ lista_items.map(item => ( item.item.st_sigla && lista_items.length >= 3 ) ? item.item.st_sigla : item.item.search).join(', ') }}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="text-nowrap">
                                                    <button type="button" class="btn btn-sm btn-outline-primary mr-1" @click.prevent="imprimir_requisicao(requisicao, 'tiss')">
                                                        SP/SADT
                                                    </button>
                                                    <button type="button" class="btn btn-sm btn-outline-primary" @click.prevent="imprimir_requisicao(requisicao)">
                                                        Padrão
                                                    </button>
                                                    <a type="button" class="btn btn-sm btn-outline-primary ml-1" :href="requisicao.doc_certificado.arquivo.temporary_url" v-if="requisicao.doc_certificado" target="_blank">
                                                        <i class="fa-solid fa-file-contract"></i>
                                                    </a>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>

                                    <div class="col col-12 col-md-6">
                                        <div class="d-flex justify-content-between">
                                            <div>Relatórios:</div>
                                            <div v-if="false">
                                                <a href="#" v-for="(tag, itx) in lista_doc_tags" :key="itx" @click.prevent="tag.selec = !tag.selec">
                                                    <span class="badge" :class="'badge-' + ( tag.selec ? 'success' : 'secondary' )">
                                                        {{ tag.tag }}
                                                    </span>
                                                </a>
                                            </div>
                                        </div>
                                        <ul class="list-group">
                                            <li class="list-group-item d-flex justify-content-between" v-if="!lista_documentos.length">
                                                Nenhum documento identificado.
                                            </li>
                                            <li class="list-group-item" v-for="(doc, idx) in lista_documentos" :key="idx">
                                                <a href="#" @click.prevent="imprimir_documento(doc)">
                                                    {{ doc.st_titulo }}
                                                </a>
                                                <a :href="doc.doc_certificado.arquivo.temporary_url" v-if="doc.doc_certificado" target="_blank">
                                                    <i class="fa-solid fa-file-contract ml-2"></i>
                                                </a>
                                                <div class="small text-muted" v-if="doc.modelo_documento && doc.modelo_documento.st_nome && doc.modelo_documento.st_nome != doc.st_titulo">
                                                    {{ doc.modelo_documento.st_nome }}
                                                </div>
                                                <div v-if="doc.modelo_documento && doc.modelo_documento.js_classes && doc.modelo_documento.js_classes.length">
                                                    <span class="badge badge-success" v-for="(tag, itx) in doc.modelo_documento.js_classes" :key="itx">{{ tag }}</span>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                            </div>
                            <az-empty-state v-else />
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        </div>
                    </div>
                </div>
            </div>

            <cuidado-paciente ref="cuidado" @refresh="load()" />

            <registrar-contatos 
                :lista_status="lista_status.filter(item => item.id_contato_status != 'R')" 
                :id_fila_lead="filtro.id_fila_lead"
                ref="regcontatos" 
                @refresh="load()">
                <template v-slot:info>
                    <template v-if="!edicao.id_atendimento && edicao.anamnese">
                        <div v-if="edicao.dt_inclusao.substr(0,10) != edicao.anamnese.atendimento_procedimento.atendimento.dt_inicio.substr(0,10)">
                            Atendimento: {{ $util.getFormatDate(edicao.anamnese.atendimento_procedimento.atendimento.dt_inicio) }}
                        </div>
                    </template>

                    <div class="alert alert-warning mb-3" v-if="edicao.st_observacoes">
                        {{ edicao.st_observacoes }}
                    </div>

                    <template v-if="edicao && edicao.id_cuidado_paciente">
                        <ul class="list-group small">
                            <li class="list-group-item d-flex justify-content-between" v-for="(retorno, irr) in edicao.retornos" :key="irr">
                                <div>{{ retorno.procedimento.search }}</div>
                                <div>{{ $util.getFormatDate(retorno.dt_retorno) }}</div>
                            </li>
                        </ul>
                    </template>

                    <template v-else-if="edicao.id_atendimento_procedimento">

                        <ul class="list-group small">
                            <li class="list-group-item d-flex justify-content-between">
                                <div>
                                    {{ edicao.procedimento.search }}
                                </div>
                                <div v-if="edicao.id_procedimento == edicao.atendimento.marcacao.id_procedimento">
                                    <button type="button" class="btn btn-outline-primary btn-sm" data-toggle2="tooltip"
                                        data-placement="top" title="Marcar" @click="agendar_retorno(edicao)">
                                        <i class="fa fa-calendar-plus-o" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </li>
                        </ul>

                    </template>

                    <template v-else-if="edicao.items">
                        <ul class="list-group small">
                            <template v-for="(lista_items, grupo, igx) in agrupar_items (edicao.items)">
                                <li class="list-group-item list-group-item-secondary d-flex justify-content-between py-1" :key="igx" v-if="grupo">
                                    <div>{{ grupo }}</div>
                                    <div>
                                        <span class="badge badge-secondary">{{ lista_items.length }}</span>
                                    </div>
                                </li>
                                
                                <li class="list-group-item d-flex justify-content-between py-2" v-for="(item, idx) in lista_items" :key="igx + '.' + idx">
                                    <div v-if="item.item">
                                        {{ item.item.search }}
                                        <span class="badge badge-secondary ml-2" v-if="item.in_quantidade > 1" title="Quantidade">x{{ item.in_quantidade }}</span>
                                        <div class="text-muted" style="white-space: pre-wrap;">{{ item.st_observacoes }}</div>
                                    </div>
                                    <div v-else-if="item.procedimento">{{ item.procedimento.search }}</div>

                                    <div v-if="item.id_requisicao_procedimento">
                                        <a href="#" @click.prevent="agendar(item)" title="Marcar">
                                            <i class="fa fa-calendar-plus-o" aria-hidden="true"></i>
                                        </a>
                                    </div>

                                    <div v-else-if="edicao.id_retorno_atendimento">
                                        <button
                                            type="button"
                                            class="btn btn-outline-primary btn-sm"
                                            data-toggle2="tooltip"
                                            data-placement="top"
                                            title="Marcar"
                                            @click="agendar_retorno(edicao)">
                                            <i class="fa fa-calendar-plus-o" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </li>
                            </template>
                        </ul>

                        <div class="mt-3" v-if="edicao.id_requisicao || ( edicao.id_receita && edicao.id_procedimento_protocolo )">
                            <div class="row" >
                                <div class="col col-12">
                                    <az-input
                                        placeholder="Operadora/Plano..."
                                        icon="far fa-credit-card"
                                        type="autocomplete"
                                        optionsMode="aql"
                                        optionsName="planos.atendimento"
                                        :optionsParm="{
                                            atendimento: true,
                                            plano_id_unidade_operacao: null, 
                                        }"
                                        service="planos.index"
                                        :optionsSync="false"
                                        v-model="edicao.plano"
                                        ref="info_plano" />
                                </div>
                            </div>

                            <div class="row mt-3">
                                <div class="col col-12 d-flex flex-column">
                                    <button type="button" class="btn btn-outline-success" @click="gerar_orcamento(edicao)">
                                        <i class="fas fa-file-invoice-dollar mr-2"></i>
                                        Gerar Orçamento
                                    </button>
                                </div>
                            </div>

                            <div class="row mt-1">
                                <div class="col col-12 d-flex flex-column">
                                    <button type="button" class="btn btn-outline-primary" @click="gerar_atendimento(edicao)">
                                        <i class="fa fa-play mr-2" aria-hidden="true"></i>
                                        Gerar Atendimento
                                    </button>
                                </div>
                            </div>

                            <div class="row mt-1" v-if="edicao && edicao.req_outras && edicao.req_outras.length">
                                <div class="col col-12 d-flex flex-column">
                                    <button type="button" class="btn" :class="add_outras ? 'btn-secondary' : 'btn-outline-secondary' " @click="add_outras = !add_outras">
                                        {{ edicao.req_outras.length == 1 ? 'Requisição' : 'Requisições' }}:
                                        <i class="fa fa-plus ml-1" aria-hidden="true"></i>{{ edicao.req_outras.length }}
                                    </button>
                                </div>
                            </div>
                        </div>

                        <ul class="list-group mt-3" v-if="edicao.orcamentos && edicao.orcamentos.length">
                            <li class="list-group-item" v-for="(orc, iox) in edicao.orcamentos" :key="iox">
                                Orçamento: 
                                <a href="#" @click.prevent="ver_orcamento(orc)" class="card-link">
                                    #{{ orc.id_orcamento }}
                                </a>
                                <template v-if="orc.marcacoes">
                                    <div v-for="(marc, imx) in orc.marcacoes" :key="imx">
                                        <div>
                                            <i class="fa fa-calendar-plus-o fa-fw mr-2" aria-hidden="true"></i>
                                            {{ $util.getFormatDate(marc.dt_inicio) }}
                                            {{ marc.dt_inicio.substr(11,5) }}
                                            <span v-if="marc.id_atendimento">
                                                <i class="fa fa-caret-right mx-3" aria-hidden="true"></i>
                                                #{{ marc.id_atendimento }}
                                            </span>
                                        </div>
                                    </div>
                                </template>
                                
                            </li>
                        </ul>

                    </template>

                    <template v-else-if="edicao.id_marcacao">
                        <ul class="list-group small">
                            <li class="list-group-item d-flex justify-content-between">
                                <div>{{ edicao.procedimento.search }}</div>
                                <div>
                                    <button type="button" class="btn btn-outline-primary btn-sm" data-toggle2="tooltip"
                                        data-placement="top" title="Remarcar" @click="remarcar(edicao)">
                                        <i class="fa fa-calendar-plus-o" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </li>
                        </ul>
                    </template>


                    <br><br><br><br><br><br><br><br><br><br>
                </template>
            </registrar-contatos>

            <assinar-requisicao ref="assreq" @refresh="load()" />

        </template>

        <br><br><br><br>

        <!-- Selecionar Itens para Integrar -->
        <div class="modal fade" id="integrarSelecModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                <div class="modal-content" v-if="lista_integra">
                    <div class="modal-header">
                        <h5 class="modal-title">Integrar Oportunidade no Kualiz
                            <span v-if="lista_integra" class="badge badge-secondary ml-2">
                                {{ lista_integra.filter(item => item.selec).length }} / {{ lista_integra.length }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <table class="table table-sm table-hover cabecalho-fixo-modal">
                            <thead>
                                <tr>
                                    <th>
                                        <a href="#" @click.prevent="select_all_integra()">
                                            <i class="fa fa-square" aria-hidden="true"></i>
                                        </a>
                                    </th>
                                    <th>Id</th>
                                    <th>Descrição</th>
                                    <th>Data</th>
                                    <th>Integração</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(orc, iox) in lista_integra" :key="iox">
                                    <td>
                                        <input type="checkbox" v-model="orc.selec">
                                    </td>
                                    <td>
                                        #{{ orc.id_orcamento }}
                                    </td>
                                    <td>
                                        {{ orc.st_titulo }}
                                    </td>
                                    <td>
                                        {{ $util.getFormatDate(orc.created_at) }}
                                    </td>
                                    <td>
                                        <span v-if="orc.integra_crm">
                                            {{ orc.integra_crm.st_id_externo }}
                                        </span>
                                        <span v-else class="text-muted">
                                            Não Integrado
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <pre v-if="false">{{ lista_integra }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="atualizar_integrar_kualiz()">Integrar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <az-dispatch
            name="integra_kualiz"
            ref="dispatchModal"
            titulo="Integrar Oportunidade no Kualiz..."
            @refresh="finalizar_integra_kualiz()" />

        <detalhe-orcamento ref="detalhe_orcamento" />

        <amostras ref="amostras" />

        <crm-anexar-laudo-externo ref="anexolaudo" />

        <crm-filtros ref="filtros" :model_type="fila ? fila.model_type : ''"/>

        <gerar-atendimento-de-requisicao ref="gerar_atend_req" />

        <!-- Envio de Arquivo -->
        <template v-if="acao_anexar && item_arq">
            <az-file-upload
                ref="upload"
                :multiple="true"
                @refresh="carregar_arquivos()"
                :arquivos="item_arq.arquivos"
                :parms="{ 
                    model_type: item_arq.model ? item_arq.model.type : '', 
                    model_id: item_arq.model ? item_arq.model.id : '', 
                    tipo_especial: null 
                }" />
        </template>
    
    </div>
</template>

<script>
// import * as moment from 'moment';
import $ from 'jquery';
import _ from 'lodash';
import AzInput from '../../shared/forms/AzInput.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import CelulaDadosPaciente from "../../shared/table/CelulaDadosPaciente.vue";
import CelulaDadosProcedimento from "../../shared/table/CelulaDadosProcedimento.vue";
import AzSubmit from '../../util/AzSubmit.vue';
import PrintExport from '../../shared/PrintExport.vue';
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';
import Importacao from '../../cadastros/shared/Importacao.vue';
import CuidadoPaciente from './CuidadoPaciente.vue';
import RegistrarContatos from '../../shared/RegistrarContatos.vue';
import AssinarRequisicao from '../consultorio/AssinarRequisicao.vue';
import CrmOrcamentos from './CrmOrcamentos.vue';
import CrmSolicitantes from './CrmSolicitantes.vue';
import CadastroMedicoSolicitante from '../../cadastros/items/CadastroMedicoSolicitante.vue';
import AzDispatch from '../../util/AzDispatch.vue';
import DetalheOrcamento from './DetalheOrcamento.vue';
import Amostras from '../laboratorio/Amostras.vue';
import CrmAnexarLaudoExterno from './CrmAnexarLaudoExterno.vue';
import CrmFiltros from './CrmFiltros.vue';
import GerarAtendimentoDeRequisicao from './GerarAtendimentoDeRequisicao.vue';
import AzFileUpload from '../../util/AzFileUpload.vue';

// moment().subtract(7, "days").format('YYYY-MM-DD')

export default {
    data () { 
        return {
            dados: null, 
            from: this.$util.hoje(),
            to: this.$util.hoje(),
            filtro: { 
                id_fila_lead: this.$util.getCookie('crm-fila'), 
                id_unidade_operacao: "", 
                id_contato_status: "", 
                inicio: "",
                fim: "",
                periodo: "do",
                semana: "",
                mes: "", 
                id_medico: "", 
                id_medico_solicitante: "", 
                id_motivo: "", 
            },
            paciente: "", 
            filas: [], 
            search: "",
            laudo: null, 
            lista_status: [], 
            novo_contato: null, 
            edicao: null, 
            validate: false, 
            canceltoken: null, 
            page: 1, 
            obs: null, 
            edicao_atendimento: null, 
            parametros: null, 
            first_load: false, 
            ja_buscou: false, 
            contadores: null, 
            flKualizCrm: false,
            tags: [],
            lista_integra: null, 
            exibir_contato: false, 
            anexar_laudo_atendido: false, 
            add_outras: false, 

            acao_anexar: false, 
            item_arq: null, 
        }
    },
    components: { 
        AzInput,
        AzEmptyState, 
        AzSubmit, 
        CelulaDadosPaciente, 
        CelulaDadosProcedimento,
        AzPeriodo, 
        PrintExport, 
        CabecalhoGenerico,
        Importacao, 
        CuidadoPaciente, 
        RegistrarContatos, 
        AssinarRequisicao, 
        CrmOrcamentos, 
        CrmSolicitantes, 
        CadastroMedicoSolicitante, 
        AzDispatch, 
        DetalheOrcamento, 
        Amostras, 
        CrmAnexarLaudoExterno, 
        CrmFiltros, 
        GerarAtendimentoDeRequisicao, 
        AzFileUpload
    },

    props: ['aba'], 

    watch: { 
        filtro: { 
            handler: function () {
                if ( !this.filtro.id_fila_lead ) 
                    return;

                // this.load ();
            },
            deep: true,
            immediate: true
        }
    },

    computed: { 
        fila_com_filtro: function () { 
            return ( this.fila && this.fila.fl_filtro_items ) ? true : false; 
        },

        tem_solicitante: function () { 
            
            if ( !this.filtro.id_fila_lead || !this.filas ) { 
                return false;
            }

            let fila = this.filas.find(item => item.id_fila_lead == this.filtro.id_fila_lead)
            
            if ( fila ) { 
                switch (fila.model_type) {
                    case 'App\\azure\\orcamento':
                        return true;
                }
            }

            return false;
            
        },

        dados_exportacao: function () { 
            if ( !this.lista || this.aba == 'visao' )
                return [];

            return this.lista.map(item => { 
                let linha = { 
                    items: item.items ? item.lista_items : '',
                    data: item.dt_inclusao
                        ? this.$util.getFormatDate(item.dt_inclusao) + ' ' + item.dt_inclusao.substr(11,5)
                        : ( item.dt_inicio 
                            ? this.$util.getFormatDate(item.dt_inicio) + ' ' + item.dt_inicio.substr(11,5) 
                            : ( item.created_at
                                ? this.$util.getFormatDate(item.created_at) + ' ' + item.created_at.substr(11,5) 
                                : ''
                            )
                        ),
                    status: item.contatos.length 
                        ? item.contatos[0].contato_status.search 
                        : 'Registrado', 
                    id_atendimento: item.id_atendimento
                        ? item.id_atendimento 
                        : ( item.anamnese
                            ? item.anamnese.atendimento_procedimento.id_atendimento
                            : ( item.marcacoes 
                                ? item.marcacoes.filter(marc => marc.id_atendimento)
                                    .map(marc => marc.id_atendimento)
                                    .join(', ')
                                : '' )
                        ),
                    id_orcamento: item.id_orcamento,
                    nome_paciente: ( item.anamnese && item.anamnese.atendimento_procedimento.atendimento.paciente ) 
                        ? item.anamnese.atendimento_procedimento.atendimento.paciente.st_nome
                        : ( item.id_atendimento_procedimento 
                            ? item.atendimento.paciente.st_nome 
                            : item.nome_paciente
                        ),
                    nome_medico: ( item.anamnese && item.anamnese.atendimento_procedimento.atendimento.medico ) 
                        ? item.anamnese.atendimento_procedimento.atendimento.medico.search
                        : ( item.id_atendimento_procedimento 
                            ? ( item.atendimento.medico ? item.atendimento.medico.search : '' ) 
                            : ( ( item.id_orcamento && !item.medico )  
                                ? this.listar_medicos_orcamento(item) 
                                : ( item.medico ? item.medico.serch : '' ) 
                            )
                        ),
                    valor: item.valor_total > 0 ? this.$util.formatMoeda(item.valor_total) : '', 
                    crm: ( item.integra_crm && item.integra_crm.st_id_externo ) ? item.integra_crm.st_id_externo : '',

                    telefone: item.paciente 
                        ? _.get(item.paciente, 'cadastro.telefones.telefone', '') 
                        : ( item.cadastro_temporario 
                            ? _.get(item.cadastro_temporario, 'st_telefone', '') 
                            : ( item.id_atendimento_procedimento 
                                ? _.get(item, 'atendimento.paciente.cadastro.telefones.telefone')
                                : _.get(item, 'anamnese.atendimento_procedimento.atendimento.paciente.cadastro.telefones.telefone')
                            )
                        ),

                    celular: item.paciente 
                        ? _.get(item.paciente, 'cadastro.telefones.celular', '') 
                        : ( item.cadastro_temporario 
                            ? _.get(item.cadastro_temporario, 'st_celular', '') 
                            : ( item.id_atendimento_procedimento 
                                ? _.get(item, 'atendimento.paciente.cadastro.telefones.celular')
                                : _.get(item, 'anamnese.atendimento_procedimento.atendimento.paciente.cadastro.telefones.celular')
                            )
                        ),

                    email: item.paciente 
                        ? _.get(item.paciente, 'cadastro.st_email', '') 
                        : ( item.cadastro_temporario 
                            ? _.get(item.cadastro_temporario, 'st_email', '') 
                            : ( item.id_atendimento_procedimento 
                                ? _.get(item, 'atendimento.paciente.cadastro.st_email')
                                : _.get(item, 'anamnese.atendimento_procedimento.atendimento.paciente.cadastro.st_email')
                            )
                        ),
                }

                if ( item.id_orcamento ) { 
                    linha.solicitante = item.solicitante ? item.solicitante.st_nome : ''; 
                    linha.usuario = item.usuario ? item.usuario.st_login : ''; 
                }

                return linha; 
            });
        },

        lista_documentos: function () { 

            if ( !this.edicao_atendimento || !this.edicao_atendimento.atendimento_procedimentos )
                return [];

            // const tags = this.lista_doc_tags.filter(tag => tag.selec);
            const tags = [];

            return this.edicao_atendimento.atendimento_procedimentos.flatMap(atp => 
                atp.anamnese.documentos.filter(doc => !tags.length 
                    || ( doc.modelo_documento && _.intersection(doc.modelo_documento.js_classes, tags.map(tag => tag.tag)).length )
                )
            );

        },

        lista_requisicoes: function () { 

            if ( !this.edicao_atendimento || !this.edicao_atendimento.atendimento_procedimentos )
                return [];

            // const tags = this.lista_doc_tags.filter(tag => tag.selec);
            // const tags = [];

            return this.edicao_atendimento.atendimento_procedimentos.flatMap(atp => atp.anamnese.requisicao);
        },

        lista: function () { 
            if ( !this.dados || this.aba == 'visao' )
                return [];

            let reg = this.$util.getregex(this.search);

            /*
            .filter(item => ( !this.filtro.id_contato_status || 
                        ( !item.contatos.length && this.filtro.id_contato_status == 'R' ) ||
                        ( item.contatos.length && item.contatos[0].id_contato_status == this.filtro.id_contato_status)))
            */

            return this.dados.data.filter(item => !this.filtro.id_status_laudo || item.id_status_laudo == this.filtro.id_status_laudo)
                    .filter(item => ( !this.search || reg.test(JSON.stringify(item)) ));
        },

        fila: function () { 
            if ( !this.filtro.id_fila_lead )
                return null;

            return this.filas.find(item => item.id_fila_lead == this.filtro.id_fila_lead);
        },

        dadosExportacao: function () { 
            return this.lista.map(item => { 

                let atendimento; 

                if ( item.anamnese && item.anamnese.atendimento_procedimento.atendimento ) { 
                    atendimento = item.anamnese.atendimento_procedimento.atendimento;
                } else if ( item.id_atendimento_procedimento ) { 
                    atendimento = item.atendimento;
                } else if ( item.marcacao ) { 
                    atendimento = item.marcacao;
                } else { 
                    atendimento = item; 
                }

                return { 
                    data: item.dt_inclusao 
                        ? item.dt_inclusao
                        : item.dt_inicio, 
                    status: item.contatos.length
                        ? item.contatos[0].contato_status.search
                        : 'Registrado', 
                    id_atendimento: item.anamnese
                        ? item.anamnese.atendimento_procedimento.id_atendimento
                        : item.id_atendimento,
                    paciente: atendimento.paciente
                        ? atendimento.paciente.st_nome
                        : ( atendimento.cadastro_temporario
                            ?  atendimento.cadastro_temporario.st_nome
                            : '-' ), 
                    plano: atendimento.plano
                        ? atendimento.plano.search
                        : '?', 
                    procedimento: atendimento.procedimento
                        ? atendimento.procedimento.search
                        : ( item.procedimento
                            ? item.procedimento.search
                            : ( item.anamnese && item.anamnese.atendimento_procedimento 
                                ? item.anamnese.atendimento_procedimento.procedimento.search
                                : '-' 
                            )
                        ),
                    medico: atendimento.medico
                        ? atendimento.medico.st_nome_exibicao
                        : '?', 
                    items: item.items
                        ? item.lista_items 
                        : '', 
                };
            });
        },

        is_fila_atendimento: function() { 

            if ( !this.filtro.id_fila_lead || !this.filas ) { 
                return false;
            }

            let fila = this.filas.find(item => item.id_fila_lead == this.filtro.id_fila_lead)
            
            if ( fila && fila.model_type == 'App\\azure\\atendimento' ) { 
                return true;
            }

            return false;

        },

        is_fila_orcamento: function() { 

            if ( !this.filtro.id_fila_lead || !this.filas ) { 
                return false;
            }

            let fila = this.filas.find(item => item.id_fila_lead == this.filtro.id_fila_lead)
            
            if ( fila && fila.model_type == 'App\\azure\\orcamento' ) { 
                return true;
            }

            return false;

        },

        is_fila_cuidado: function() { 

            if ( !this.filtro.id_fila_lead || !this.filas ) { 
                return false;
            }

            let fila = this.filas.find(item => item.id_fila_lead == this.filtro.id_fila_lead)
            
            if ( fila && fila.model_type == 'App\\azure\\cuidadoPaciente' ) { 
                return true;
            }

            return false;

        },
    },

    methods: { 
        abrir_anexar_arquivo (item) { 
            console.log('arquivos', item);
        },
        
        listar_medicos_orcamento(orcamento) { 
            if ( !orcamento || !orcamento.js_procedimentos || !orcamento.js_procedimentos.length ) { 
                return '';
            }

            let medicos = orcamento.js_procedimentos.map(proc => _.get(proc, 'medico.search', ''))
                .filter(med => med)
                .sort();

            return _.uniq(medicos).join(', ');
        },

        gerar_atendimento (requisicao) { 
            this.$refs.gerar_atend_req.abrir(requisicao);
        },

        incluir_filtro () { 
            this.$refs.filtros.abrir(this.filtro.id_fila_lead); 
        },

        anexar_laudo (item) { 
            this.$refs.anexolaudo.abrir(item, this.filtro.id_fila_lead);
        },

        verColeta (item) { 
            this.$refs.amostras.abrir(item.id_atendimento, false, "");
        },

        agrupar_items (lista, pela_sigla = false) { 
            let info_grupo = pela_sigla ? 'item.grupo.st_sigla' : 'item.grupo.search';
            let lista_geral = _.cloneDeep(lista);

            if ( !this.edicao ) { 
                return []; 
            }

            if ( this.edicao.id_requisicao && this.add_outras ) { 
                lista_geral = lista_geral.concat( this.edicao.req_outras.flatMap(req => req.items) );
            }

            return _.groupBy(
                _.orderBy(lista_geral, item => _.get(item, info_grupo, _.get(item, 'item.grupo.search', ''))), 
                item => { 
                    return _.get(item, info_grupo, _.get(item, 'item.grupo.search', ''));
                }
            );
        },

        abrir_atendimento (id_atendimento) { 
            this.$util.abrir_atendimento(this, id_atendimento);
        },

        atualizar_integrar_kualiz() { 
            this.$refs.dispatchModal.executar_chunck(
                'crm',
                'integrar_com_kualiz_lista',
                this.lista_integra.filter(item => item.selec),
                'lista',
                {},
                5
            );
        },

        finalizar_integra_kualiz () { 
            $('.modal').modal('hide');

            this.load();

            this.$toast.add({
                severity: "success",
                summary: "Atenção",
                detail: "Processo concluído.",
                life: 3000
            });
        },

        select_all_integra () { 
            let selec = this.lista_integra.find(item => item.selec) ? true : false;

            this.lista_integra.forEach(element => {
                element.selec = !selec;
            });
        },

        integrar_todos () { 
            this.lista_integra = _.cloneDeep(this.lista).map(item => { 
                let orc = { 
                    selec: true, 
                    id_orcamento: item.id_orcamento,
                    st_titulo: item.st_titulo,
                    created_at: item.created_at,
                    integra_crm: item.integra_crm, 
                    id_fila_lead: this.filtro ? this.filtro.id_fila_lead : -1, 
                }

                return orc;
            });

            $('#integrarSelecModal').modal('show');
        },

        chamar_orcamento(item) { 

            if ( !confirm('Confirma chamar o paciente ' + item.nome_paciente + '?') ) { 
                return;
            }

            this.$util.atualizar(this, { 
                service: 'chamada_painel',
                func: 'chamar',
                dados: { 
                    id_paciente: item.id_paciente, 
                    nome: item.nome_paciente, 
                    id_unidade_operacao: item.id_unidade_operacao, 
                    id_recepcao: this.$util.getCookie('id_recepcao'),
                    local: this.$util.getCookie('local-chamada'),
                    block_painel: this.$util.getCookie('nao-enviar-painel'),
                },
                toast: true, 
                msg: 'Chamada realizada', 
            });

        },

        set_pesquisa (texto) { 
            if ( this.search == '"' + texto + '"' ) { 
                this.search = ""; 
            } else { 
                this.search = '"' + texto + '"';
            }   
        },

        totalizar (lista, campo) { 
            return lista.reduce((total, carry) => { 
                return total + carry[campo];
            }, 0);
        },

        abrir(aba) { 
            if ( aba != this.aba ) { 
              this.$router.push({ path: '/crm/' + aba });
            }

            this.set_bread(aba);

            this.ja_buscou = false;
        },

        set_bread (aba = null) { 

            if ( !aba )
                aba = this.aba;

            if ( aba == 'visao' ) { 

                this.$store.commit("setBreadcrumb", [
                    { name: "CRM", path: "/crm/visao" },
                    { name: "Visão Geral", path: "/crm/visao" },
                ]);

            } else { 

                this.$store.commit("setBreadcrumb", [
                    { name: "CRM", path: "/crm/visao" },
                    { name: "Lista", path: "/crm/lista" },
                ]);

            }

        },

        assinar_requisicao (item) { 
            this.$refs.assreq.abrir(item, item.anamnese.atendimento_procedimento.atendimento);
        },

        incluir_programa() { 
            if ( !this.paciente ) { 
                this.$toast.add({ 
                    severity: 'error', 
                    summary: 'Atenção!', 
                    detail: 'Selecione o paciente.',
                    life: 5000 
                });

                return;
            }

            this.$refs.cuidado.incluir_programa(this.paciente);
        },
        
        ver_orcamento(orcamento) { 
            $('.modal').modal('hide');

            this.$refs.detalhe_orcamento.abrir(orcamento.id_orcamento);

            // this.$router.push({ name: 'crmorcamento', params: { id_orcamento: orcamento.id_orcamento } });
        },
        
        selecionar_paciente (nome) { 
            this.search = ( this.search == nome ) 
                ? '' 
                : nome;
        },

        imprimir_requisicao(dados, modelo = null) {
            if ( !dados )
                return;

            this.$util.print_preview('imprimir/requisicao/' + dados.id_requisicao, true, { modelo: modelo, ia: true }, true);
        },

        imprimir_documento(doc) {
            if ( !doc )
                return;

            this.$util.print_preview('imprimir/documento/' + doc.id_documento_atendimento, true);
        },

        ver_documentos (item, req = false) { 
            this.edicao_atendimento = null;
            this.validate = false;

            const id_atendimento = req 
                ? _.get(item, 'anamnese.atendimento_procedimento.id_atendimento')
                : item.id_atendimento;

            this.$nextTick(() => {
                $('#documentosModal').modal('show');

                this.$util.load(this, {
                    service: 'crm',
                    func: 'documentos',
                    parms: {
                        id: id_atendimento,
                    },
                    loadTo: res => {
                        this.edicao_atendimento = res.atendimento;        
                    }
                });
            });
        },

        gerar_orcamento (item) { 
            let item_2_orc = _.cloneDeep(item);

            if ( item.id_requisicao && this.edicao && this.edicao.req_outras && ( item.id_requisicao == this.edicao.id_requisicao ) ) { 
                item_2_orc.items = item_2_orc.items.concat(this.edicao.req_outras.flatMap(req => req.items));
            }

            this.$refs.gerar_atend_req.abrir(item_2_orc, null, true);

            /*
            console.log('itemmm', item);

            $(".modal").modal('hide');

            this.$nextTick(() => { 

                this.$router.push(
                    {
                        name: 'crmorcamento', 
                        params: { 
                            origem: item
                        } 
                    }
                );

            });
            */
        },

        paginar (page) {
            this.page = page;
            this.load();
        },

        agendar (item) { 
            $('[data-toggle="tooltip"]').tooltip("dispose");
            $('.modal').modal('hide');

            this.$nextTick(() => { 
                this.$router.push({
                    name: "call-center",
                    params: { id_requisicao_procedimento: item.id_requisicao_procedimento }
                });
            });
        },

        agendar_retorno (item) { 
            $('[data-toggle="tooltip"]').tooltip("dispose");
            $('.modal').modal('hide');

            this.$nextTick(() => { 
                this.$router.push({
                    name: "call-center",
                    params: { 
                        adicao: item.atendimento.marcacao.id_marcacao,
                        retorno: true, 
                    }
                });
            });
        },

        remarcar (item) { 
            $('[data-toggle="tooltip"]').tooltip("dispose");
            $('.modal').modal('hide');

            this.$nextTick(() => { 
                this.$router.push({
                    name: "call-center",
                    params: { 
                        remarcacao: item.id_marcacao,
                    }
                });
            });
        },

        laudo_status(status) {

            this.$util.atualizar(this, { 
                service: 'laudos',
                func: 'status',
                dados: { 
                    id_laudo: this.laudo.id_laudo,
                    id_status_laudo: status.id_status_laudo,
                    local: this.$util.getCookie('local-chamada')
                },
                toast: true, 
                modal: 'procedimentoModal', 
                callback: res => { 
                    if ( res == 'OK' ) { 
                        this.load();
                    }
                }
            });

        },

        editar(item) { 
            this.edicao = _.cloneDeep(item);

            if ( item.id_requisicao ) { 
                this.edicao.req_outras = this.lista.filter(i => i.id_requisicao != item.id_requisicao && _.get(i, 'anamnese.atendimento_procedimento.atendimento.id_paciente') && ( _.get(i, 'anamnese.atendimento_procedimento.atendimento.id_paciente') == _.get(item, 'anamnese.atendimento_procedimento.atendimento.id_paciente') ) );
            }

            this.$refs.regcontatos.editar(item);

            /*

            this.validate = false;

            this.novo_contato = { 
                model_type: item.model.type, 
                model_id: item.model.id, 
                id_contato_status: "",
                st_observacoes: "", 
            };

            this.edicao = _.cloneDeep(item);
            $('#crmContatosModal').modal('show');

            */
        },

        salvar_contato() { 
            this.$util.atualizar(this, { 
                service: 'crm',
                func: 'save_contato',
                dados: this.novo_contato,
                modal: 'crmContatosModal',
                reload: true, 
            });
        },

        dados_paciente(laudo) { 
            return { 
                marcacao: { 
                    plano: laudo.atendimento_procedimento.atendimento.plano,
                    paciente: laudo.atendimento_procedimento.atendimento.paciente, 
                    unidade_operacao: laudo.atendimento_procedimento.atendimento.marcacao
                        ? laudo.atendimento_procedimento.atendimento.marcacao.unidade_operacao
                        : null, 
                }
            };
        },

        dados_procedimento(laudo) { 
            return { 
                marcacao: { 
                    procedimento: laudo.atendimento_procedimento.procedimento,
                    medico: laudo.atendimento_procedimento.atendimento.medico, 
                    arquivos: ( laudo.id_receita || laudo.id_requisicao ) 
                        ? laudo.arquivos
                        : ( 
                            laudo.atendimento_procedimento.atendimento.marcacao
                                ? laudo.atendimento_procedimento.atendimento.marcacao.arquivos
                                : []
                        ),
                    doc_pre_atends: laudo.atendimento_procedimento.atendimento.marcacao
                        ? laudo.atendimento_procedimento.atendimento.marcacao.doc_pre_atends
                        : [], 
                    unidade_operacao: laudo.atendimento_procedimento.atendimento.marcacao
                        ? laudo.atendimento_procedimento.atendimento.marcacao.unidade_operacao
                        : _.get(laudo, 'atendimento_procedimento.atendimento.avulso.unidade_operacao'), 
                }
            };
        },

        dados_procedimento_atp(atp) { 
            return { 
                marcacao: { 
                    procedimento: atp.procedimento,
                    medico: atp.atendimento.medico, 
                    arquivos: atp.atendimento.marcacao.arquivos,
                    doc_pre_atends: atp.atendimento.marcacao.doc_pre_atends, 
                    unidade_operacao: atp.atendimento.marcacao.unidade_operacao, 
                }
            };
        },

        dados_procedimento_orc(orc) { 
            return { 
                marcacao: { 
                    procedimento: _.get(_.first(orc.items), 'procedimento'),
                    medico: null, 
                    arquivos: orc.arquivos,
                    doc_pre_atends: [], 
                    unidade_operacao: orc.unidade_operacao, 
                },
                total_items: orc.total_items, 
            };
        },

        load() { 
            if ( !this.filtro.id_fila_lead ) { 
                this.$toast.add({ 
                    severity: 'error', 
                    summary: 'Atenção!', 
                    detail: 'Selecione o tipo.',
                    life: 5000 
                });
                return;
            }

            const options = { 
                name: 'crm-filtro',
                list: this.filtro, 
            };

            this.$store.commit('setOptions', options);

            if ( this.canceltoken ) {
                this.canceltoken.cancel('#BC#');
            }

            this.canceltoken = this.axios.CancelToken.source();

            this.first_load = true;

            this.$util.load(this, { 
                service: 'crm',
                func: 'leads',
                canceltoken: this.canceltoken.token,
                parms: { 
                    fila: true, 
                    ...this.filtro,
                    add_filtros: ( this.filtro.id_fila_lead && this.$refs.filtros ) ? this.$refs.filtros.get_filtros(this.filtro.id_fila_lead) : [], 
                    id_paciente: this.paciente ? this.paciente.id_pessoa : "", 
                    aba: this.aba, 
                    page: this.page,
                    size: 100, 
                },
                loadTo: res => { 
                    if ( this.aba == 'visao' ) { 
                        this.contadores = res.lista;
                        this.tags = [];
                    } else { 
                        this.dados = res.lista;
                        this.tags = res.tags;
                    }

                    this.lista_status = res.status
                    this.obs = res.obs;
                    this.parametros = res.filtro;

                    if ( this.lista_status ) { 
                        this.lista_status.push({ 
                            id_contato_status: 'R',
                            st_contato_status: 'Registrado',
                            search: 'Registrado',
                        });
                    }
                }
            });
        },

        integrar_com_kualiz(item) {

            let dados = {
                id_orcamento: item.id_orcamento,
                id_fila_lead: this.filtro.id_fila_lead
            };

            const idExterno = _.get(item, 'integra_crm.st_id_externo');

            if(idExterno) {
                dados.id_externo = idExterno;
            }

            this.$util.atualizar(this, { 
                service: 'crm',
                func: 'integrar_com_kualiz',
                dados: dados,
                callback: res => {

                    const status = res.status_code;

                    this.$toast.add({ 
                        severity: status == 200 ? 'success' : 'error', 
                        summary: status == 200 ? 'Sucesso' : 'Erro', 
                        detail: res.msg,
                        life: 5000 
                    });

                    this.load();

                }
            });

        }
    },

    beforeMount() {
        if ( this.$store.state.options['crm-filtro'] ) { 
            this.filtro = this.$store.state.options['crm-filtro'];
        }
    },

    mounted() { 
        this.$store.commit("setBreadcrumb", [
            { name: "CRM", path: "/crm" }
        ]);

        this.$util.loadItem(this, { 
            service: 'fila_leads',
            func: 'index',
            parms: { 
                todas: true, 
            }
        })
        .then(res => { 
            this.filas = res
        });

        let query = {
            q: [
                {
                    name: "configuracoes.check",
                    id: "kualiz_crm",
                    parms:  {
                        st_slug: "integracao-crm-kualiz",
                        st_valor: "1",
                    }
                },
                {
                    name: "configuracoes.check",
                    id: "anexar_laudo_atendido",
                    parms:  {
                        st_slug: "crm-atendidos-anexar-laudo",
                        st_valor: "1",
                    }
                }
            ]
        }

        this.axios.post('/aql', query)
            .then(res => {
          
                if(res.data.kualiz_crm.status == 200) {
                    this.flKualizCrm = res.data.kualiz_crm.data
                }

                if(res.data.anexar_laudo_atendido.status == 200) {
                    this.anexar_laudo_atendido = res.data.anexar_laudo_atendido.data
                }

            }
        );

    }
    
}
</script>

